import { useState, useCallback } from "react";

import {
  FullAddress,
  FullAddressInterface,
} from "../../../common/types/interfaces";
import { getApi } from "../../../api/api";

export const useAddressManagement = () => {
  const api = getApi();

  const [addresses, setAddresses] = useState<FullAddressInterface[]>([]);
  const [selectedAddressId, setSelectedAddressId] = useState<number | null>(
    null,
  );
  const [loading, setLoading] = useState(false);

  const loadAddresses = useCallback(async () => {
    try {
      setLoading(true);
      const result = await api.getAddresses();
      const list = result || [];
      setAddresses(list);

      if (!selectedAddressId) {
        const general = list.find((addr) => addr.isGeneral);
        if (general) setSelectedAddressId(general.id);
      }
    } catch {
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  }, [api, selectedAddressId]);

  const createAddress = useCallback(
    async (payload: FullAddress) => {
      await api.createAddress(payload);
      await loadAddresses();
    },
    [api, loadAddresses],
  );

  const selectedAddress = selectedAddressId
    ? addresses.find((addr) => addr.id === selectedAddressId) || null
    : null;

  return {
    addresses,
    selectedAddressId,
    setSelectedAddressId,
    selectedAddress,
    loading,
    loadAddresses,
    createAddress,
  };
};
